import { Header } from '@/types/store';
import { HeaderDataSchema, ItemSchema } from '../schema/store';
import { ItemType, StoreItem } from '../types/store';

export const validateStoreItems = (items: StoreItem[]): { id: number; errors: string[] }[] | null => {
    const validationErrors: { id: number; errors: string[] }[] = [];
    items.forEach(item => {
        const validation = ItemSchema.safeParse(item);

        if (!validation.success) {
            const errors = validation.error.errors.map(err => {
                const path = err.path.join('.');
                return path ? `${path}: ${err.message}` : err.message;
            });

            validationErrors.push({ id: Number(item.id), errors });
        }
    });

    return validationErrors.length > 0 ? validationErrors : null;
};

export const validateHeader = (header: Header): { id: string; errors: string[] }[] | null => {
    const validation = HeaderDataSchema.safeParse(header);
    if (!validation.success) {
        const errors = validation.error.errors.map(err => {
            const path = err.path.join('.');
            return path ? `${path}: ${err.message}` : err.message;
        });
        return [{ id: ItemType.HEADER, errors }];
    }
    return null;
};
